export default __webpack_public_path__ + "static/media/location-unavailable-bottom-pattern.a693c76e.png";